import { cn } from "@/lib/utils";

export function Spinner({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "animate-spin rounded-full border-2 will-change-transform",
        className,
        "border-t-transparent"
      )}
    />
  );
}

/** Centered loading spinner for full-section loading states. */
export function SpinnerCenter({ className }: { className?: string }) {
  return (
    <div className={cn("flex justify-center py-16", className)}>
      <Spinner className="size-6 border-primary" />
    </div>
  );
}
